import { useEffect } from "react";

const LODGIFY_SCRIPT_URL = "https://app.lodgify.com/portable-search-bar/stable/renderPortableSearchBar.js";

const LODGIFY_STYLES = `
  :root {
    --ldg-psb-background: #ffffff;
    --ldg-psb-border-radius: 0.42em;
    --ldg-psb-box-shadow: 0px 24px 54px 0px rgba(0, 0, 0, 0.1);
    --ldg-psb-padding: 14px;
    --ldg-psb-input-background: #ffffff;
    --ldg-psb-button-border-radius: 3.58em;
    --ldg-psb-color-primary: #95704c;
    --ldg-psb-color-primary-lighter: #cab8a6;
    --ldg-psb-color-primary-darker: #4b3826;
    --ldg-psb-color-primary-contrast: #ffffff;
    --ldg-semantic-color-primary: #95704c;
    --ldg-semantic-color-primary-lighter: #cab8a6;
    --ldg-semantic-color-primary-darker: #4b3826;
    --ldg-semantic-color-primary-contrast: #ffffff;
    --ldg-component-modal-z-index: 999;
  }
  #lodgify-search-bar {
    width: 100%;
  }
`;

const LodgifySearchBar = () => {
  useEffect(() => {
    // Inject styles if not already present
    if (!document.getElementById("lodgify-widget-styles")) {
      const styleEl = document.createElement("style");
      styleEl.id = "lodgify-widget-styles";
      styleEl.textContent = LODGIFY_STYLES;
      document.head.appendChild(styleEl);
    }

    // Load script if not already present
    if (!document.getElementById("lodgify-widget-script")) {
      const scriptEl = document.createElement("script");
      scriptEl.src = LODGIFY_SCRIPT_URL;
      scriptEl.defer = true;
      scriptEl.id = "lodgify-widget-script";
      document.body.appendChild(scriptEl);
    }

    return () => {
      document.getElementById("lodgify-widget-styles")?.remove();
      document.getElementById("lodgify-widget-script")?.remove();
    };
  }, []);

  return (
    <div
      id="lodgify-search-bar"
      data-website-id="637794"
      data-language-code="en"
      data-checkout-page-url="https://checkout.lodgify.com/thecottageatflowerpot/en/#/768336"
      data-dates-check-in-label="Check-in"
      data-dates-check-out-label="Check-out"
      data-guests-counter-label="Guests"
      data-guests-input-singular-label="{{NumberOfGuests}} guest"
      data-guests-input-plural-label="{{NumberOfGuests}} guests"
      data-location-input-label="Location"
      data-search-button-label="Search"
      data-dates-input-min-stay-tooltip-text='{"one":"Minimum {minStay} night","other":"Minimum {minStay} nights"}'
      data-guests-breakdown-label="Guests"
      data-adults-label='{"one":"adult","other":"adults"}'
      data-adults-description="Ages {minAge} or above"
      data-children-label='{"one":"child","other":"children"}'
      data-children-description="Ages {minAge}-{maxAge}"
      data-children-not-allowed-label="Not suitable for children"
      data-infants-label='{"one":"infant","other":"infants"}'
      data-infants-description="Under {maxAge}"
      data-infants-not-allowed-label="Not suitable for infants"
      data-pets-label='{"one":"pet","other":"pets"}'
      data-pets-not-allowed-label="Not allowed"
      data-done-label="Done"
      data-new-tab="true"
      data-version="stable"
      data-has-guests-breakdown=""
    />
  );
};

export default LodgifySearchBar;
